import {useState} from "react";
import {changeEmailRequest, ChangeEmailRequestFormItem} from "../../changeEmailRequestApi";
import {Rules, ValidationErrors, Validator} from "common";

export function validateChangeEmailRequest(values: ChangeEmailRequestFormItem) {
  const rules: Rules = {
    password: Validator.rule.string().required(),
    email: Validator.rule.string().required(),
  };
  return Validator.validate(rules, values, "ChangeEmailForm");
}

interface useChangeEmailRequestFormProps {
  onRequestSent: Function;
}

export default function useChangeEmailRequestForm({onRequestSent}: useChangeEmailRequestFormProps) {
  const [item, setItem] = useState<ChangeEmailRequestFormItem>({} as ChangeEmailRequestFormItem);
  const [errors, setErrors] = useState<ValidationErrors>({});
  const [loading, setLoading] = useState<boolean>(false);

  async function process() {
    setLoading(true);
    const result = validateChangeEmailRequest(item);
    setErrors(result.errors);

    if (!result.success) {
      setLoading(false);
      return;
    }

    try {
      const response = await changeEmailRequest(item);
      setLoading(false);
      const data = response.data;

      if (!data || !data.success) {
        setErrors(response.error.form_errors);
      } else {
        onRequestSent(item.email);
      }
    } catch (e) {
      setErrors({
        password: "Unknown error",
      })
    }
  }

  function onChange(values: ChangeEmailRequestFormItem) {
    setItem(values);
  }

  return {
    item,
    errors,
    loading,
    process,
    onChange,
  };
}